"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M3.146 3.146a.5.5 0 0 1 .708 0L8.5 7.793l2.646-2.647A.5.5 0 0 1 12 5.5v5.793l2.478 2.478c.44-.569.647-1.18.647-1.771 0-.724-.309-1.477-.979-2.146a.5.5 0 0 1 .708-.708c.83.83 1.271 1.828 1.271 2.854 0 .877-.323 1.734-.935 2.483l1.874 1.874C18.368 15.064 19 13.52 19 12c0-1.823-.91-3.682-2.8-5.1a.5.5 0 0 1 .6-.8C18.91 7.682 20 9.824 20 12c0 1.813-.757 3.602-2.23 5.064l3.084 3.082a.5.5 0 0 1-.708.708l-17-17a.5.5 0 0 1 0-.708M11 10.293V6.707L9.207 8.5zM3 10.5A1.5 1.5 0 0 1 4.5 9h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h2.793a1 1 0 0 1 .707.293l3 3V15.5a.5.5 0 0 1 1 0v3a.5.5 0 0 1-.854.354L7.293 15H4.5A1.5 1.5 0 0 1 3 13.5z"
}), 'Mute');
